import { NavLink } from 'react-router-dom';

const NavLinkExt = ({label, path, className, activeClass, inactiveClass, external, ...rest}) => {

    return (
        <>
            {external
            ?
            <a key={path} href={path} className={`${className} ${inactiveClass || ''}`}>{label}</a>
            :
            <NavLink
                key={path}
                to={path}
                className={({isActive}) => 
                    `${className}
                    ${isActive ? activeClass || '' : inactiveClass || ''}`}
                    {...rest}
            >{label}</NavLink>}
        </>
    )
};

export default NavLinkExt;